import React, {Component} from 'react'
/** OWN COMPONENTS **/
import NodeForm from './NodeForm/nodeForm'
import NodeList from './NodeList/NodeList'
import './AdminNodes.css'
/*** REDUX  ****/
import * as DevicesActions from '../../../actions/devices'

import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
/** REACT TOOLBOX ***/
import '../../../assets/react-toolbox/theme.css';
import theme from '../../../assets/react-toolbox/theme.js';
import ThemeProvider from 'react-toolbox/lib/ThemeProvider';
import {Route, Switch, withRouter} from "react-router-dom";
import NotFound from "../../Route/error404";
import {PropsRoute} from "../../Route";


class AdminNodes extends Component {

    constructor() {
        super();

        this.state = {
            pag: 0,
            order: {
                active: false,
                status: [0, 0, 0, 0, 0, 0, 0]
            }
        };

        this.handleSensorsPage = this.handleSensorsPage.bind(this);
        this.handleOrder = this.handleOrder.bind(this);
    }

    // componentDidMount() {
        // this.props.devicesActions.getAllDevices();
    // }

    handleSensorsPage(direction, count) {

        if (direction === "next" && count > this.state.pag + 20) {
            this.setState({...this.state, pag: this.state.pag+20});
        }
        else if (direction === "previous" && this.state.pag > 0) {
            this.setState({...this.state, pag: this.state.pag-20});
        }
    }

    handleOrder(key) {
        let newState = this.state.order;

        if (this.state.order.status[key] === 0) {
            newState.active = true;
            newState.status = [0, 0, 0, 0, 0, 0, 0];
            newState.status[key] = 1;
        } else if (this.state.order.status[key] === 1) {
            newState.status = [0, 0, 0, 0, 0, 0, 0];
            newState.status[key] = 2;
        } else {
            newState.active = false;
            newState.status = [0, 0, 0, 0, 0, 0, 0];
        }

        this.setState({...this.state, order: newState});
    }
    
    render() {
        return (
            <ThemeProvider theme={theme}>
                <div className="row dashboardContent">
                    <Switch>
                        <PropsRoute exact path="/admin/nodes/detail/:id" component={NodeForm}/>
                        <PropsRoute exact path="/admin/nodes" component={NodeList} pag={this.state.pag} handlePage={this.handleSensorsPage} order={this.state.order} handleOrder={this.handleOrder}/>
                        <PropsRoute exact path="/dashboard" component={NodeList} pag={this.state.pag} handlePage={this.handleSensorsPage} order={this.state.order} handleOrder={this.handleOrder}/>
                        <Route path='*' component={NotFound}/>
                    </Switch>
                </div>
            </ThemeProvider>
        )
    }

}

const dashboardDispatchToProps = (dispatch) => {
    return {
        devicesActions: bindActionCreators(DevicesActions, dispatch)
    }
};
export default withRouter(connect(null, dashboardDispatchToProps)(AdminNodes))



// WEBPACK FOOTER //
// ./src/components/DashBoard/AdminNodes/AdminNodes.js